module.exports = __webpack_public_path__ + "fonts/fa-solid-900.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fa-solid-900.woff2
// module id = 53
// module chunks = 0